import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from "@/store";
import Loading from 'vue-loading-overlay';
import '@fortawesome/fontawesome-free/css/all.css';
import VueQriously from 'vue-qriously';
import './services/GlobalVariables.js';

Vue.use(VueQriously);
Vue.component('loading', Loading);
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
